import { useState } from "react";
import { Link } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { getAdminPermission } from "../../../lib/bandung/bandung";

export default function Drawer({ className, open, action }) {
  const isAdmin = getAdminPermission();
  const [openEve, setOpenEve] = useState(false);
  const [openConv, setOpenConv] = useState(false);
  const [openCat, setOpenCat] = useState(false);

  const handleClickEve = () => {
    setOpenEve(!openEve);
  };

  const handleClickConv = () => {
    setOpenConv(!openConv);
  };

  const handleClickCat = () => {
    setOpenCat(!openCat);
  };

  const eventsItems = isAdmin
    ? {
        "/event": "Upcoming events",
        "/event/previous": "Previous events",
        "/event/new": "Create a new event",
        "/event/pending": "Pending events",
      }
    : {
        "/event": "Upcoming events",
        "/event/previous": "Previous events",
        "/event/new": "Create a new event",
      };

  const conversationItems = isAdmin
    ? {
        "/conversation": "Conversation List",
        "/conversation/create": "Create a new conversation",
        "/conversation/edit": "Update a conversation",
        "/conversation/delete": "Delete a conversation",
      }
    : {
        "/conversation": "Conversation List",
      };


    // Added Manufacturing Comapnies Category List
    const categoryItems = 
     {
      "/category": "Category List", 
    }
  


  return (
    <>
      <div
        className={`drawer-wrapper w-full  h-full relative  ${className || ""}`}
      >
        {open && (
          <div
            onClick={action}
            className="w-full h-screen bg-black bg-opacity-40 z-40 left-0 top-0 fixed"
          ></div>
        )}
        <div
          className={`w-[280px] transition-all duration-300 ease-in-out h-screen overflow-y-auto overflow-x-hidden overflow-style-none bg-white fixed left-0 top-0 z-50 ${
            open ? "left-0" : "-left-[280px]"
          }`}
        >
          <div className="w-full px-5 mt-5 mb-4">
            <div className="flex justify-end">
              <CloseIcon onClick={action} />
            </div>
          </div>
          <div className="menu-item mt-5 w-full">
            <ul className="categories-list">
              <li className="category-item">
                <Link to="/">
                  <div className=" flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">Home</span>
                    </div>
                  </div>
                </Link>
              </li>
              <li className="category-item">
                <Link to="/about">
                  <div className="flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">About</span>
                    </div>
                  </div>
                </Link>
              </li>
              <li className="category-item">
                <Link to="/event">
                  <div
                    className=" flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer"
                    onClick={handleClickEve}
                  >
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">Events</span>
                    </div>
                    {openEve ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </div>
                </Link>
                {openEve && (
                  <ul className="submenu-list ml-5">
                    {Object.entries(eventsItems).map(([link, label]) => (
                      <li className="category-item" key={link}>
                        <Link to={link}>
                          <div className=" flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                            <div className="flex items-center space-x-6">
                              <span className="text-sm font-400">{label}</span>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li className="category-item">
                <Link to="/conversation">
                  <div
                    className="flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer"
                    onClick={handleClickConv}
                  >
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">Conversations</span>
                    </div>
                    {openConv ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </div>
                </Link>
                {openConv && (
                  <ul className="submenu-list ml-5">
                    {Object.entries(conversationItems).map(([link, label]) => (
                      <li className="category-item" key={link}>
                        <Link to={link}>
                          <div className=" flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                            <div className="flex items-center space-x-6">
                              <span className="text-sm font-400">{label}</span>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li className="category-item">
                <Link to="/category">
                  <div
                    className="flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer"
                    onClick={handleClickCat}
                  >
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">Categories</span>
                    </div>
                    {openCat ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </div>
                </Link>
                {openCat && (
                  <ul className="submenu-list ml-5">
                    {Object.entries(categoryItems).map(([link, label]) => (
                      <li className="category-item" key={link}>
                        <Link to={link}>
                          <div className=" flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                            <div className="flex items-center space-x-6">
                              <span className="text-sm font-400">{label}</span>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li className="category-item">
                <Link to="/contact">
                  <div className="flex justify-between items-center px-5 h-12 bg-white hover:bg-[#f5f5f5] transition-all duration-300 ease-in-out cursor-pointer">
                    <div className="flex items-center space-x-6">
                      <span className="text-sm font-400">Contact</span>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
